import Flickity from './Library';


// Set labels
let language = document.documentElement.lang;
const STRINGS = {
    de: ['Gehe zu %n. Slide', 'Vorherige Slide', 'Nächste Slide'],
    default: ['Go to slide #%n', 'Previous slide', 'Next slide']
};

if (!STRINGS.hasOwnProperty(language)) {
    language = 'default';
}

// Set additional default values
const DEFAULTS = {
    imagesLoaded: true,
    pageDotAriaLabel: STRINGS[language][0],
    previousAriaLabel: STRINGS[language][1],
    nextAriaLabel: STRINGS[language][2],
    pageDots: false,
    arrowShape: "M75.3223 93.129c1.5558 1.5732 1.5558 4.1208 0 5.6928-1.5558 1.5698-4.0766 1.572-5.6359 0l-45.5196-45.98c-1.5557-1.572-1.5557-4.1173 0-5.6882L69.6864 1.1782c1.5593-1.5698 4.0778-1.572 5.636 0 1.5557 1.572 1.5557 4.1196 0 5.6917l-41.514 43.1278 41.514 43.1313z"
};

Object.assign(Flickity.defaults, DEFAULTS);

// Add localized labels with this duck-punch code
// https://metafizzy.co/blog/duck-punching-prototype/

let addDots = Flickity.PageDots.prototype.addDots;
Flickity.PageDots.prototype.addDots = function() {
    addDots.apply(this, arguments);
    let ariaLabel = this.parent.options.pageDotAriaLabel;
    this.dots.forEach(function(dot, i) {
        let label = ariaLabel.replace('%n', i + 1);
        dot.setAttribute('aria-label', label);
    });
};

let _createButton = Flickity.PrevNextButton.prototype._create;
Flickity.PrevNextButton.prototype._create = function() {
    _createButton.apply(this, arguments);
    let optionName = this.isPrevious ? 'previous' : 'next';
    let label = this.parent.options[optionName + 'AriaLabel'];
    this.element.setAttribute('aria-label', label);
};

// Enable buttons only if there are more than one slide
let _createPrevNextButtons = Flickity.prototype._createPrevNextButtons;
Flickity.prototype._createPrevNextButtons = function() {
    if (this.element.childNodes.length <= 1) {
        return;
    }
    _createPrevNextButtons.apply(this, arguments);
};

// Make Flickity global (used for events)
window.Flickity = Flickity;